import styled from 'styled-components'
import { cyberColors } from '../../../lib/colors'
import { SCORES_STYLED_PROPS } from './interface'

export const ContentWrapper = styled.div`
  display: flex;
  transform: translateZ(200px);
`
export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 50%;
`
export const TitleWrapper = styled.div<SCORES_STYLED_PROPS>`
  width: 100%;
  display: flex;
  text-transform: uppercase;
  justify-content: center;
  margin-top: 18px;
  .text {
    margin-left: 3px;
    font-size: 14px;
    background: ${({ initial }) =>
      initial ? cyberColors.blueGradient : cyberColors.redGradient};
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    clip-path: inset(0.5px);
  }
`
export const Title = styled.p<SCORES_STYLED_PROPS>`
  text-transform: uppercase;
  font-size: 14px;
  clip-path: inset(0 0.5px 0.5px 0.1px);
  font-family: ${({ font }) => font || 'Regular'};
  background: ${({ win }) =>
    win ? cyberColors.greenGradient : cyberColors.greyText};
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  clip-path: inset(1px 0.2px);
`

export const Result = styled.p<SCORES_STYLED_PROPS>`
  font-size: 44px;
  text-shadow: 0px 4px 14px rgba(0, 0, 0, 0.25);
  background: ${({ res, win }) =>
    res ? cyberColors.greyText : win ? cyberColors.greenGradient : '#393A4B'};
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  clip-path: inset(1px 0.5px);
  &&.roll {
    background: ${({ rollUnder }) =>
      rollUnder ? cyberColors.blueGradient : cyberColors.redGradient};
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
`
export const Separator = styled.span`
  width: 1px;
  height: 59px;
  z-index: 2;
  transform: translateZ(300px);
  background: linear-gradient(
    rgba(57, 58, 75, 0) 0%,
    rgba(57, 58, 75, 0.5745) 18.23%,
    #393a4b 48.96%,
    rgba(57, 58, 75, 0.5918) 78.13%,
    rgba(57, 58, 75, 0) 100%
  );
  background: -webkit-linear-gradient(
    rgba(57, 58, 75, 0) 0%,
    rgba(57, 58, 75, 0.5745) 18.23%,
    #393a4b 48.96%,
    rgba(57, 58, 75, 0.5918) 78.13%,
    rgba(57, 58, 75, 0) 100%
  );
`
